import { render, staticRenderFns } from "./showdatainviteviews.vue?vue&type=template&id=6ed324b2&"
import script from "./showdatainviteviews.vue?vue&type=script&lang=js&"
export * from "./showdatainviteviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports